import * as React from 'react';
import { userInfo, ChangePassword } from '../api/dataTypes';
import { UserAccountComponent } from './UserAccountComponent';
import { EditPasswordModal } from '../modals/modal-EditPassword';
import '../styles/App.css';

interface State {
    editPasswordModalOpen: boolean;
}

export interface Props {
    userInfo: userInfo;
    handleChange: (name: string, value: string | number) => void;
    handleSave: () => void;
    message: string;
    changePassword: (changePassword: ChangePassword) => void;
    passwordChangeMessage: string;
}

export class UserAccountInfo extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {
            editPasswordModalOpen: false,
        };
    }

    render() {
        let accountInfo = this.props.userInfo;
        return (
            accountInfo &&
            <div className="w-100">
                <div className="row flex-container list-divider mt-2">
                    <div className="col-2 dropdown-text-style">
                        Username/Email
                    </div>
                    <div className="col">
                        {accountInfo.email}
                    </div>
                </div>
                <UserAccountComponent
                    handleChange={this.props.handleChange}
                    value={accountInfo.firstName}
                    APIName="firstName"
                    fieldName="First Name"
                />
                <UserAccountComponent
                    handleChange={this.props.handleChange}
                    value={accountInfo.lastName}
                    APIName="lastName"
                    fieldName="Last Name"
                />
                <UserAccountComponent
                    handleChange={this.props.handleChange}
                    value={accountInfo.phone}
                    APIName="phone"
                    fieldName="Phone"
                //type="number"
                />
                <div className="col list-divider">
                    <div className="row align-content-center mb-4">
                        <div className="col-1" />
                        <button
                            className="col-2 btn button-standard mt-4"
                            onClick={() => this.props.handleSave()}
                        >
                            Save
                        </button>
                        <div className="col d-flex ml-2 dropdown-text-style">
                            {this.props.message}
                        </div>
                    </div>
                </div>
                <div className="row flex-container mt-2 align-content-center">
                    <div className="col-2 dropdown-text-style">
                        Password
                    </div>
                    <button
                        className="col-2 btn button-standard ml-2 mt-4"
                        onClick={() => this.openModal()}
                    >
                        Change Password
                    </button>
                </div>
                <EditPasswordModal
                    isModalOpen={this.state.editPasswordModalOpen}
                    closeModal={this.closeModal}
                    message={this.props.passwordChangeMessage}
                    changePassword={this.props.changePassword}
                    email={this.props.userInfo.email}
                />
            </div>
        );
    }

    openModal = () => {
        this.setState({
            editPasswordModalOpen: true
        });
    }

    closeModal = () => {
        this.setState({
            editPasswordModalOpen: false
        });
    }
}
